
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import logo from '../img/logo.png'

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className='left-panel'>
        <button
            className="menu-toggle"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            ☰
        </button>
        {/* Logo */}
        <div className="logo">
          <img
            src={logo} // Replace with the actual logo path after uploading
            alt="Indosam Cricket Club Logo"
          />
        </div>
        </div>
      
      <ul className={`nav-list ${isOpen ? 'active' : ''}`}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/matches">Matches</Link></li>
        <li><Link to="/players">Players</Link></li>
        <li><Link to="/news">News</Link></li>
        <li><Link to="/gallery">Gallery</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>
      </div>
    </nav>
  );
}

export default Navbar;